<template>
  <div class="canvasChart"></div>
</template>

<script>
// import echarts from 'echarts'

export default {
  name: 'canvasChart',
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.canvasChart{
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// canvasChart.vue?f2adba6c